import React from 'react';

import FlexibleProductEditView from '@components/shared/flexible_products/FlexibleProductEditView';
import PageHeader from '@shared/PageHeader';
import { useTranslation } from 'react-i18next';

import adminFlexibleProductService from '@services/admin/flexibleProductService';
import adminProductService from '@services/admin/productService';

// Admin session 鎖定單一 merchant，編輯時不需要 record→header 同步（永遠相同 merchant）。
// 但仍把 prop 介面保持與 operator wrapper 一致，由 shared 統一處理 ProductSelect 的 merchantId。
const AdminFlexibleProductEdit: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader basePath="/admin" items={['products', 'products.flexible', { label: t('common.button.edit') }]} />
      <FlexibleProductEditView
        flexibleProductService={adminFlexibleProductService}
        productService={adminProductService}
        role="admin"
      />
    </div>
  );
};

export default AdminFlexibleProductEdit;
